import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
// @mui
import { Link, Stack, IconButton, InputAdornment, TextField, Checkbox, Alert } from '@mui/material';
import { LoadingButton } from '@mui/lab';
// components
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import { useForm } from 'react-hook-form';
import Iconify from '../../../components/iconify';
import { useAuth } from '../../../hooks/useAuth';

// ----------------------------------------------------------------------

const loginSchema = yup.object().shape({
  email: yup.string().email('Zlý format e-mailu').required('Povinné'),
});

export default function LoginForm() {
  const navigate = useNavigate();

  const { login, loading, error } = useAuth();

  const [showPassword, setShowPassword] = useState(false);

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
  } = useForm({ resolver: yupResolver(loginSchema) });

  const onSubmit = async (data) => {
    if (data) {
      const { email, password } = data;
      login(email, password);
    }
  };

  return (
    <>
      <Stack spacing={3}>
        <TextField
          name="email"
          label="E-mail"
          error={errors.email}
          helperText={errors.email?.message}
          {...register('email')}
        />

        <TextField
          name="password"
          label="Heslo"
          type={showPassword ? 'text' : 'password'}
          sx={{ pb: 3 }}
          {...register('password')}
          InputProps={{
            endAdornment: (
              <InputAdornment position="end">
                <IconButton onClick={() => setShowPassword(!showPassword)} edge="end">
                  <Iconify icon={showPassword ? 'eva:eye-fill' : 'eva:eye-off-fill'} />
                </IconButton>
              </InputAdornment>
            ),
          }}
        />
      </Stack>

      {/* <Stack direction="row" alignItems="center" justifyContent="space-between" sx={{ my: 2 }}>
        <Checkbox name="remember" label="Remember me" />
        <Link variant="subtitle2" underline="hover">
          Forgot password?
        </Link>
        </Stack> */}

      <LoadingButton
        fullWidth
        size="large"
        type="submit"
        variant="contained"
        loading={loading}
        onClick={handleSubmit(onSubmit)}
      >
        Login
      </LoadingButton>
      {error ? (
        <Alert severity="error" sx={{ mt: 2 }}>
          Zadali ste zle prihlasovacie údaje!
        </Alert>
      ) : (
        false
      )}
    </>
  );
}
